import { OrderPreference } from '~/booking/types'
import { TutorBookingCommonFields } from '~/types/cart'

export function createBookingForSelfCartItemFromOrderPreference(
  preference: Partial<OrderPreference>,
): Partial<TutorBookingCommonFields> {
  return {
    location: preference.city,
    subjects: (preference.subjects?.subjects ?? []).map((subject: any) => subject.name ?? subject),
    levelsOfEducation: preference.subjects?.levelsOfEducation ?? [],
    language: preference.languagePrimary,
    includeTravelExpense: preference.includeTravelExpense,
  }
}
